import React, {Component} from 'react';
import api from '../../utils/api';
import { connect } from 'react-redux';
import {twoDecimals} from '../../utils/helpers';

class SimulacionOutro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prodTitles:{},
            prodShortTitles: {},
            priceFields: {
                1: "weighted_increase",
                2: "min_price",
                3: "max_price"
            },
            priceTitles: {
                1: "Aumento Ponderado",
                2: "Precio Mínimo",
                3: "Precio Máximo"
            }
        }
    }

    componentWillMount(){
        let _self = this;
        api.get("filters/products/").then((out) => {
            let pTitles = {};
            let pShortTitles = {};
            let i = 1;

            out.data.forEach(e => {
                pTitles[i] = e.name;
                pShortTitles[i] = e.short_name;
                i++;
            });

            _self.setState({prodTitle : pTitles, prodShortTitles : pShortTitles});
        })
    }

    render(){
        let _self = this;
        let data = _self.props.data;
        let i = 0;

        if(data && data.cluster_weights && data.details && data.details.cluster_simulation_list) {
            let prices = {
              'Aumento Ponderado': {},
              'Precio Mínimo': {},
              'Precio Máximo': {}
            };

            data.details.cluster_simulation_list.forEach(cluster => {
              cluster.products_table.forEach(prod => {
                if (!prices['Aumento Ponderado'][prod.product_shortname]) prices['Aumento Ponderado'][prod.product_shortname] = 0;
                if (!prices['Precio Mínimo'][prod.product_shortname]) prices['Precio Mínimo'][prod.product_shortname] = 999999999999;
                if (!prices['Precio Máximo'][prod.product_shortname]) prices['Precio Máximo'][prod.product_shortname] = 0;

                data.cluster_weights.forEach(c => {
                    if (c['cluster_id'] === cluster.cluster_id) {
                        c.products.forEach(p => {
                            if (p['product_id'] === prod.product_id) {
                                prices['Aumento Ponderado'][prod.product_shortname] += (prod.new_increase) * (p['weight_percentage'] / 100);
                            }
                        });
                    }
                });

                prices['Precio Mínimo'][prod.product_shortname] = Math.min(prices['Precio Mínimo'][prod.product_shortname], prod.new_reference_price);
                prices['Precio Máximo'][prod.product_shortname] = Math.max(prices['Precio Máximo'][prod.product_shortname], prod.new_reference_price);
              });
            });

            let total = 0;
            Object.keys(prices['Aumento Ponderado']).forEach(p => {
                total += prices['Aumento Ponderado'][p];
            });

            return (
                <div>
                    <div className="simulador_simulacion_main-content_sim-outro">
                        <div className="simulador_simulacion_main-content_sim-outro_sim-box">
                            <table className='c-table strategy'>
                                <thead className="no-border">
                                <tr>
                                    <td></td>
                                    {_self.state.prodShortTitles && Object.keys(_self.state.prodShortTitles).map(key =>
                                        <td key={key}>{_self.state.prodShortTitles[key]}</td>
                                    )}
                                    <td >Total</td>
                                </tr>
                                </thead>
                                <tbody>
                                {Object.keys(prices).map(key => {
                                    i++;
                                    return <tr key={key+i} className="bordeable">
                                        <td>{key}</td>
                                        {Object.keys(prices[key]).map(field => {
                                            return <td key={key+i+field}>{twoDecimals(prices[key][field])}</td>
                                        })}
                                        {key === 'Aumento Ponderado' && <td>{twoDecimals(total)}</td>}
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }
        else{
            return <div></div>
        }
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(SimulacionOutro);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulacionoutro.js